export const RESET_NETWORK_DATA = 'SERVICES/RESET_NETWORK_DATA'
export const FETCH_NETWORKS_DATA = 'SERVICES/FETCH_NETWORKS_DATA'
export const SET_LOADING = 'SERVICES/SET_LOADING'
export const SET_NETWORKS_LIST = 'SERVICES/SET_NETWORKS_LIST'
export const FETCH_NETWORK_DATA = 'SERVICES/FETCH_NETWORK_DATA'
export const SET_NETWORK_DATA = 'SERVICES/SET_NETWORK_DATA'
export const FETCH_NETWORK_ACCOUNT = 'SERVICES/FETCH_NETWORK_ACCOUNT'
export const FETCH_NETWORK_ACCOUNTS = 'SERVICES/FETCH_NETWORK_ACCOUNTS'
export const FETCH_NETWORK_TEXT = 'SERVICES/FETCH_NETWORK_TEXT'
export const SET_ACCOUNTS_FILTERS = 'SERVICES/SET_ACCOUNTS_FILTERS'
export const UPDATE_ACCOUNTS = 'SERVICES/UPDATE_ACCOUNTS'
export const SET_NETWORK_ACCOUNTS = 'SERVICES/SET_NETWORK_ACCOUNTS'
export const SET_NETWORK_ACCOUNTS_QUERY = 'SERVICES/SET_NETWORK_ACCOUNTS_QUERY'
export const TOGGLE_PROCESSING = 'SERVICES/TOGGLE_PROCESSING'
export const REMOVE_NETWORK_ACCOUNTS = 'SERVICES/REMOVE_NETWORK_ACCOUNTS'
export const REMOVE_AND_FETCH_NETWORK_ACCOUNTS = 'SERVICES/REMOVE_AND_FETCH_NETWORK_ACCOUNTS'
export const SET_SELECTION = 'SERVICES/SET_SELECTION'
export const UPDATE_ACCOUNT_BY_ID = 'SERVICES/UPDATE_ACCOUNT_BY_ID'
export const NETWORK_QUERY_TYPE = 'SERVICES/NETWORK_QUERY_TYPE'
export const PROCESS_NETWORK_GROUP_ACTION_WITH_CONFIRM =
  'SERVICES/PROCESS_NETWORK_GROUP_ACTION_WITH_CONFIRM'
export const ACCESS_SET_LOADING = 'SERVICES/ACCESS_SET_LOADING'
export const ACCESSES_SET_LIST = 'SERVICES/ACCESSES_SET_LIST'
export const SET_TRANSFERS_DATA = 'SERVICES/SET_TRANSFERS_DATA'
export const SET_ACCOUNT_TRANSFERS_QUERY = 'SERVICES/SET_ACCOUNT_TRANSFERS_QUERY'
export const SET_ACCOUNT_TRANSFERS_FILTERS = 'SERVICES/SET_ACCOUNT_TRANSFERS_FILTERS'
export const SET_ACCOUNT_DATA = 'SERVICES/SET_ACCOUNT_DATA'
export const INIT_ACCOUNT = 'SERVICES/INIT_ACCOUNT'
export const ACCOUNT_UPDATE_TRANSFERS = 'SERVICES/ACCOUNT_UPDATE_TRANSFERS'
export const ACCESS_SET_FILTER = 'SERVICES/ACCESS_SET_FILTER'
export const ACCESS_SET_PROCESSING_IDS = 'SERVICES/ACCESS_SET_PROCESSING_IDS'
export const ACCESS_REMOVE_FROM_LIST = 'SERVICES/ACCESS_REMOVE_FROM_LIST'
export const ACCESS_DROP_LIST = 'SERVICES/ACCESS_DROP_LIST'
export const ACCESS_QUERY_TYPE = 'SERVICES/ACCESS_QUERY_TYPE'
export const ACCESS_CREATE = 'SERVICES/ACCESS_CREATE'
export const ACCESS_DELETE = 'SERVICES/ACCESS_DELETE'
export const ACCOUNT_TRANSFERS_FILTERS_APPLY = 'SERVICES/ACCOUNT_TRANSFERS_FILTERS_APPLY'
export const ACCOUNT_TRANSFERS_CLEAN = 'SERVICES/ACCOUNT_TRANSFERS_CLEAN'
export const FETCH_ACCOUNT_TRANSFERS = 'SERVICES/FETCH_ACCOUNT_TRANSFERS'
export const RESET_ACCOUNT_DATA = 'SERVICES/RESET_ACCOUNT_DATA'
export const UPDATE_ACCOUNT_NAME = 'SERVICES/UPDATE_ACCOUNT_NAME'
export const ACCOUNT_QUERY_TYPE = 'SERVICES/ACCOUNT_QUERY_TYPE'
export const ACCOUNT_DELETE = 'SERVICES/ACCOUNT_DELETE'
export const ACCOUNT_ARCHIVE = 'SERVICES/ACCOUNT_ARCHIVE'
export const ACCOUNT_LOAD_DATA_FAILED = 'SERVICES/ACCOUNT_LOAD_DATA_FAILED'
export const ACCOUNT_CREATE_CONNECT_MANUAL_LOAD = 'SERVICES/ACCOUNT_CREATE_CONNECT_MANUAL_LOAD'
export const SET_ACCOUNT_CONNECT_MANUAL = 'SERVICES/SET_ACCOUNT_CONNECT_MANUAL'
export const SET_YANDEX_USERS = 'SERVICES/SET_YANDEX_USERS'
export const SET_NETWORK_TEXT = 'SERVICES/SET_NETWORK_TEXT'
export const YANDEX_SUBSCRIPTION_CAMPAIGN_SET_DATA =
  'SERVICES/YANDEX_SUBSCRIPTION_CAMPAIGN_SET_DATA'
export const CAMPAIGNS_LOAD_DATA_FAILED = 'SERVICES/CAMPAIGNS_LOAD_DATA_FAILED'
export const ACCESS_FETCH = 'SERVICES/ACCESS_FETCH'
export const NETWORK_ACCOUNTS_CLEAN = 'SERVICES/NETWORK_ACCOUNTS_CLEAN'
export const UPDATE_NETWORK_ACCOUNTS_STATUS = 'SERVICES/UPDATE_NETWORK_ACCOUNTS_STATUS'
export const CREATE_NEW_ACCOUNT = 'SERVICES/CREATE_NEW_ACCOUNT'
export const FETCH_NETWORK_SETTINGS = 'SERVICES/FETCH_NETWORK_SETTINGS'
export const FETCH_YANDEX_USERS = 'SERVICES/FETCH_YANDEX_USERS'
export const SET_NETWORK_PAYMENT_ACCOUNTS = 'SERVICES/SET_NETWORK_PAYMENT_ACCOUNTS'
export const SET_NETWORK_SETTINGS = 'SERVICES/SET_NETWORK_SETTINGS'
export const FETCH_ADVERTISING_TYPES = 'SERVICES/FETCH_ADVERTISING_TYPES'
export const NETWORK_SET_SORTING = 'SERVICES/NETWORK_SET_SORTING'
export const SET_NETWORK_ACCOUNT_QUERY = 'SERVICES/SET_NETWORK_ACCOUNT_QUERY'
export const REFUND_CREATE = 'SERVICES/REFUND_CREATE'
export const CREATE_MULTIPLE_ACCOUNTS = 'SERVICES/CREATE_MULTIPLE_ACCOUNTS'
export const YANDEX_SUBSCRIPTION_CAMPAIGN_CREATE = 'SERVICES/YANDEX_SUBSCRIPTION_CAMPAIGN_CREATE'
export const YANDEX_SUBSCRIPTION_CAMPAIGN_START = 'SERVICES/YANDEX_SUBSCRIPTION_CAMPAIGN_START'
export const YANDEX_SUBSCRIPTION_CAMPAIGNS_FETCH = 'SERVICES/YANDEX_SUBSCRIPTION_CAMPAIGNS_FETCH'
export const YANDEX_SUBSCRIPTION_CAMPAIGN_FETCH = 'SERVICES/YANDEX_SUBSCRIPTION_CAMPAIGN_FETCH'
export const YANDEX_SUBSCRIPTION_CAMPAIGN_DELETE = 'SERVICES/YANDEX_SUBSCRIPTION_CAMPAIGN_DELETE'
export const FETCH_NETWORK_PAYMENTS_ACCOUNTS = 'SERVICES/FETCH_NETWORK_PAYMENTS_ACCOUNTS'
export const SET_CAMPAIGNS_LIST = 'SERVICES/SET_CAMPAIGNS_LIST'
export const CAMPAIGNS_CLEAN = 'SERVICES/CAMPAIGNS_CLEAN'
export const YANDEX_SUBSCRIPTION_CAMPAIGN_DELETED = 'SERVICES/YANDEX_SUBSCRIPTION_CAMPAIGN_DELETED'
export const MAIN_FILTERS_APPLY = 'SERVICES/MAIN_FILTERS_APPLY'
export const SET_FILTERS = 'SERVICES/SET_FILTERS'
export const PATCH_ACCOUNT_ADVERTISER_INFO = 'SERVICES/PATCH_ACCOUNT_ADVERTISER_INFO'

export const GET_ACCOUNT_EXTRA_DATA = 'SERVICES/GET_ACCOUNT_EXTRA_DATA'
export const ACCOUNTS_ARCHIVE_TOGGLE = 'SERVICES/ACCOUNTS_ARCHIVE_TOGGLE'
export const ACCESS_FOR_PASSPORT_ORGANIZATION_CREATE =
  'SERVICES/ACCESS_FOR_PASSPORT_ORGANIZATION_CREATE'

export const CONFIRM_EXIT_FROM_CREATE_ACCOUNT = 'SERVICES/CONFIRM_EXIT_FROM_CREATE_ACCOUNT'
